import { render } from "./ShowLiveTableDialog.vue?vue&type=template&id=5bf6719a&scoped=true"
import script from "./ShowLiveTableDialog.vue?vue&type=script&lang=js"
export * from "./ShowLiveTableDialog.vue?vue&type=script&lang=js"

import "./ShowLiveTableDialog.vue?vue&type=style&index=0&id=5bf6719a&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bf6719a"]])

export default __exports__